export default __webpack_public_path__ + "static/media/shoharab.ae6531a7.png";